var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 88.5,
    fill: "white",
    fillOpacity: 0.2,
    stroke: "#535B66",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6775_9499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.778 73.3334V59.5423C115.916 52.5561 113.282 45.7996 108.451 40.7512C103.62 35.7028 96.9855 32.7735 90 32.6045C83.0145 32.7735 76.3804 35.7028 71.5494 40.7512C66.7184 45.7996 64.0838 52.5561 64.2222 59.5423V73.3334H54.5555V128.111C54.5555 129.82 55.2345 131.46 56.4431 132.668C57.6516 133.877 59.2908 134.556 61 134.556H119C120.709 134.556 122.348 133.877 123.557 132.668C124.765 131.46 125.444 129.82 125.444 128.111V73.3334H115.778ZM93.2222 106.297V115.222H86.7778V106.007C85.209 105.2 83.9634 103.88 83.2477 102.268C82.5319 100.655 82.389 98.8464 82.8427 97.1415C83.2964 95.4366 84.3194 93.9381 85.742 92.8946C87.1646 91.8511 88.9012 91.3254 90.6636 91.4047C92.4261 91.4841 94.1084 92.1636 95.4315 93.3306C96.7546 94.4977 97.6389 96.082 97.9376 97.8208C98.2363 99.5595 97.9316 101.348 97.0739 102.89C96.2162 104.432 94.8571 105.634 93.2222 106.297ZM109.333 73.3334H70.6667V59.5423C70.5277 54.265 72.4832 49.1473 76.1058 45.3074C79.7284 41.4674 84.7236 39.2174 90 39.0489C95.2764 39.2174 100.272 41.4674 103.894 45.3074C107.517 49.1473 109.472 54.265 109.333 59.5423V73.3334Z",
    fill: "#535B66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6775_9499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 116,
    fill: "white",
    transform: "translate(32 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCircle);
export default __webpack_public_path__ + "static/media/lockCircle.8cbc282afb53a0d072f585720dba2151.svg";
export { ForwardRef as ReactComponent };